import React, { useContext, useEffect, useRef, useState } from "react"
import { GameBoardContext } from "../../../../context/createContext"
import { ToggleMenuWrapper } from "../ElementsStyles"
import Menu from "./Menu"

export default function ToggleMenu() {
  const { settings, funcs } = useContext(GameBoardContext)
  const { handleSettings, handleSettingsSubpage } = funcs
  const menuRef = useRef<any>(null)

  const [isOutside, setisOutside] = useState(false)

  const handleClickOutside = (event: any) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setisOutside(true)
    }
  }

  useEffect(() => {
    !settings.showSettings && setisOutside(false)
    settings.showSettings &&
      document.addEventListener("click", handleClickOutside, true)
    return () => {
      document.removeEventListener("click", handleClickOutside, true)
    }
  }, [settings.showSettings])

  useEffect(() => {
    if (isOutside) {
      handleSettings(false)
      handleSettingsSubpage("")
    }
  }, [isOutside])

  return (
    <ToggleMenuWrapper ref={menuRef} showSettings={settings.showSettings}>
      <Menu
        showMenu={
          settings.showSettings || settings.settingsSubpage === "Settings"
        }
      />
    </ToggleMenuWrapper>
  )
}
